import { makeStyles } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import ClearIcon from "@material-ui/icons/Clear";
import ContentFilter from "@material-ui/icons/FilterList";
import cl from "classnames";
import { get } from "lodash";
import React from "react";
import { Button, useListContext, useTranslate } from "react-admin";

const useStyles = makeStyles({
	add_filter: {},
	reset_filter: {
		color: red[500],
	},
	button: {
		whiteSpace: "nowrap",
	},
});

const FilterButton = () => {
	const classes = useStyles();
	const {
		showFilter,
		displayedFilters,
		setFilters,
		loading,
		hideFilter,
		filterValues,
	} = useListContext();
	const visible =
		get(displayedFilters, "main") || Object.keys(filterValues).length > 0;
	const translate = useTranslate();
	const resetFilter = () => {
		hideFilter("main");
		setFilters({}, []);
	};
	const handleClick = () => {
		if (visible) {
			resetFilter();
		} else {
			showFilter("main");
		}
	};
	return (
		<Button
			size="small"
			color="primary"
			onClick={handleClick}
			className={cl(
				classes.button,
				classes[visible ? "reset_filter" : "add_filter"]
			)}
			disabled={loading}
			label={
				visible
					? translate("ra.action.hide_filter")
					: translate("ra.action.add_filter")
			}
		>
			{visible ? <ClearIcon /> : <ContentFilter />}
		</Button>
	);
};

export default FilterButton;
